import React from "react";
import DefaultLayout from "../layouts/DefaultLayout";
import ProjectSummary from "../sections/Project/ProjectSummary";
import Faqs from "../sections/Faqs";
import AppRichText from "../sections/App/AppRichText";
import AppFeatures from "../sections/App/AppFeatures";
import ProjectGallery from "../sections/Project/ProjectGallery";
import AppBanner from "../sections/App/AppBanner";
import AppMeta from "../sections/App/AppMeta";
import DefaultHelmet from "../seo/DefaultHelmet";
import AppSmallTextBlocks from "../sections/App/AppSmallTextBlocks";
import AppFeature from "../sections/App/AppFeature";
import beaconWidgetIds from "../settings/beacon-widget-ids";
import useBeaconWidget from "../hooks/useBeaconWidget";
import useSchemaSettings from "../seo/schema/useSchemaSettings";
import { buildAppPageSchema } from "../seo/schema";
import ProductsSlider from "../sections/ProductsSlider/ProductsSlider";

const App = ({pageContext}) => {
    const { productsSliderItems } = pageContext;
    const {
        acfApp,
        title: appName,
        page_header: pageHeader,
    } = pageContext.app;

    const getSection = ({fieldGroupName, ...section}, index) => {
        const key = index;

        switch (fieldGroupName) {
            case 'app_Acfapp_Sections_AppBanner': {
                return (
                    <div key={key}>
                        <AppBanner
                            title={section.showTitle && appName}
                            pageHeader={pageHeader}
                            {...section}
                        />
                        <AppMeta/>
                    </div>
                );
            }

            case 'app_Acfapp_Sections_AppSummary': {
                return (
                    <ProjectSummary
                        key={key}
                        withManual
                        className="project-summary--secondary"
                        {...section}
                    />
                );
            }

            case 'app_Acfapp_Sections_AppFaqs': {
                return (
                    <Faqs
                        key={key}
                        {...section}
                    />
                );
            }

            case 'app_Acfapp_Sections_AppGallery': {
                return (
                    <ProjectGallery
                        key={key}
                        projectTitle={appName}
                        {...section}
                    />
                );
            }

            case 'app_Acfapp_Sections_AppRichText': {
                return (
                    <AppRichText
                        key={key}
                        {...section}
                    />
                )
            }

            case 'app_Acfapp_Sections_AppFeatures': {
                return (
                    <AppFeatures
                        key={key}
                        {...section}
                    />
                );
            }

            case 'app_Acfapp_Sections_AppFeature': {
                return (
                    <AppFeature
                        key={key}
                        projectTitle={appName}
                        {...section}
                    />
                );
            }

            case 'app_Acfapp_Sections_AppSmallTextBlocks': {
                return (
                    <AppSmallTextBlocks
                        key={key}
                        {...section}
                    />
                );
            }

            default: {
                return null;
            }
        }
    };

    const getSections = () => {
        const sections = acfApp?.sections;

        if (!Array.isArray(sections)) {
            return null;
        }

        return sections.map(getSection);
    };

    const pageTitle = acfApp?.metaData?.title || appName;
    const pageDescription = acfApp?.metaData?.description || `Page about UTD application: ${appName}`;
    const pageKeywords = "UTD, Shopify App, Shopify"
    const schemaContext = useSchemaSettings();
    const structuredData = buildAppPageSchema({
        schemaContext,
        app: pageContext.app,
        title: pageTitle,
        description: pageDescription,
    });

    useBeaconWidget(beaconWidgetIds.APP);

    return (
        <DefaultLayout preFooterSections={<ProductsSlider items={productsSliderItems} />}>
            <DefaultHelmet title={pageTitle} description={pageDescription} keywords={pageKeywords} structuredData={structuredData}/>

            {getSections()}
        </DefaultLayout>
    );
};

export default App;
